<template>
  <div v-if="isVisible"
       class="iq-indicator"
       :title="$t('title')"
  >
    <div class="diamond" />
    <div class="caption">
      {{ $t('caption') }}
    </div>
  </div>
</template>

<script>
  import { onDprChange } from '../../lib/utility/dom-helpers';
  import { getHiDpiRatio } from '../../render-settings';

  export default {
    name: 'IqIndicator',
    i18nOptions: { keyPrefix: 'uScope.extensions.image-quality-indicator' },
    data () {
      return {
        isVisible: false
      };
    },
    mounted () {
      onDprChange((newDpr) => {
        this.isVisible = newDpr !== getHiDpiRatio();
      });
    }
  };
</script>

<style scoped lang="scss">
@import "~lbs-pi-web-styles/lib/variables";

.iq-indicator {
  position: absolute;
  top: 10px;
  left: 40px;
  z-index: 999;
  font-family: $lbs-font-family;
  font-size: 14px;
  user-select: none;
  opacity: .6;
}
// mimic the leica style guide "warning" icon (yellow triangle)
$diamond-size: 15px;
.diamond {
  width: 0;
  height: 0;
  border: $diamond-size solid transparent;
  border-bottom-color: $leica-yellow;
  position: relative;
  top: -$diamond-size;

  &:after {
    content: '';
    position: absolute;
    left: -$diamond-size;
    top: $diamond-size;
    width: 0;
    height: 0;
    border: $diamond-size solid transparent;
    border-top-color: $leica-yellow;
  }
}
.caption {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  color: white;
  line-height: 3;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/uScope/js/extensions/image-quality-indicator/IqIndicator.vue